import {
    INVENTORY_GET_SUCCESS,
    INVENTORY_RESET_ON_PPID_CHANGE,
} from '../actionTypes/InventoryActionTypes';

const InventoryReducer = function InventoryReducer(state = [], action) {
    switch (action.type) {
        case INVENTORY_GET_SUCCESS:
            return [].concat(action.inventory);
        case INVENTORY_RESET_ON_PPID_CHANGE:
            return [];
        default:
            return state;
    }
};

InventoryReducer.reducerName = 'inventory';

export default InventoryReducer;
